(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drawer-cart"]) return;
  try {
    
        class CartNote extends HTMLElement {
          constructor() {
            super();

            this.addEventListener(
              'change',
              debounce((event) => {
                const body = JSON.stringify({ note: event.target.value });
                fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
              }, 300)
            );
          }
        }
        customElements.define('cart-note', CartNote);

        class CheckoutAgreement extends HTMLElement {
          constructor() {
            super();

            this.addEventListener('change', function (event) {
              console.log('CheckoutAgreement - event', event);
              let checkbox = event.target;

              if (checkbox.checked) {
                this.activateCheckout();
                this.checkCheckboxes();

                let labelCheckoutAgreement = document.querySelectorAll('.checkout-agreement > label');
                if (labelCheckoutAgreement) {
                  labelCheckoutAgreement.forEach((labelCheckbox) => {
                    labelCheckbox.classList.remove('with-errors');
                  });
                }
              } else {
                this.disableCheckout();
                this.uncheckCheckboxes();
              }
            });
          }

          activateCheckout() {
            let checkoutButton = document.querySelectorAll('.cart__checkout-button');
            if (checkoutButton) {
              checkoutButton.forEach((button) => {
                button.classList.remove('disabled');
              });
            }
          }

          checkCheckboxes() {
            let checkouts = document.querySelectorAll('.checkout_agreement__input');
            if (checkouts) {
              checkouts.forEach((checkout) => {
                checkout.checked = true;
              });
            }
          }

          uncheckCheckboxes() {
            let checkouts = document.querySelectorAll('.checkout_agreement__input');
            if (checkouts) {
              checkouts.forEach((checkout) => {
                checkout.checked = false;
              });
            }
          }

          disableCheckout() {
            let checkoutButton = document.querySelectorAll('.cart__checkout-button');
            if (checkoutButton) {
              checkoutButton.forEach((button) => {
                button.classList.add('disabled');
              });
            }
          }
        }
        customElements.define('checkout-agreement', CheckoutAgreement);

        class CheckoutButton extends HTMLElement {
          constructor() {
            super();

            this.addEventListener('DOMContentLoaded', function () {
              let inputAgreement = document.querySelector('.checkout_agreement__input');
              if (inputAgreement && inputAgreement.checked) {
                this.activateCheckout();
              }
            });

            this.addEventListener('click', function (event) {
              let button = event.target;
              let inputCheckoutAgreement = document.querySelector('.checkout_agreement__input');
              let labelCheckoutAgreement = null;
              if (inputCheckoutAgreement && !inputCheckoutAgreement.checked) {
                labelCheckoutAgreement = document.querySelectorAll('.checkout-agreement > label');
              }

              if (labelCheckoutAgreement) {
                labelCheckoutAgreement.forEach((label) => {
                  label.classList.add('with-errors');
                });
              } else {
                labelCheckoutAgreement.forEach((label) => {
                  label.classList.remove('with-errors');
                });
              }

              if (button.classList.contains('disabled')) {
                event.preventDefault();
                event.stopPropagation();
              } else {
                if (typeof beginCheckoutGtm === 'function') {
                  beginCheckoutGtm();
                }
              }
            });
          }

          activateCheckout() {
            let checkoutButton = document.querySelectorAll('.cart__checkout-button');
            if (checkoutButton) {
              checkoutButton.forEach((button) => {
                button.classList.remove('disabled');
              });
            }
          }
        }
        customElements.define('checkout-button', CheckoutButton);
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"], input[name="currency_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
      this.querySelectorAll('li > p').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  class MarketsLocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
      this.querySelectorAll('li > p').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const countryCode = event.currentTarget.dataset.countryCode;
      const languageCode = event.currentTarget.dataset.languageCode;
      this.updateLocalization({country: countryCode, language: languageCode});
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }

    updateLocalization({country, language}) {
      const formId = crypto.randomUUID();
      const formHtml = `
        <form id="${formId}" action="/localization" method="POST" style="display: none;">
          <input name="_method" value="PUT">
          <input name="country_code" value="${country}">
          <input name="language_code" value="${language}">
        </form>
      `;
      document.body.insertAdjacentHTML("beforeend", formHtml);
      document.getElementById(formId).submit();
    }
  }

  customElements.define('markets-localization-form', MarketsLocalizationForm);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            loadCollectionQuickAddClickListeners();

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      const viewedRecommendations = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        if (posthog && typeof viewItemListPH === 'function') {
          let items = this.querySelectorAll('.product__grid-item');
          if (items) {
            let list = {
              name: 'Recommended products',
              type: 'list',
              mainProduct: {
                id: parseInt(this.dataset.productId),
                loc: parseInt(this.dataset.loc)
              },
              items: []
            };
            items.forEach(item => {
              list.items.push({
                id: parseInt(item.dataset.productId),
                title: item.dataset.title,
                loc: parseInt(item.dataset.loc),
                category: item.dataset.category
              });
            });
            viewItemListPH(list);
          }
        }
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
      new IntersectionObserver(viewedRecommendations.bind(this), {rootMargin: '0px 0px 0px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  class CompleteYourLook extends HTMLElement {
    constructor() {
      super();

      const viewedCompleteYourLook = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        if (posthog && typeof viewItemListPH === 'function') {
          let items = this.querySelectorAll('.product__grid-item');
          if (items) {
            let list = {
              name: 'Complete your look',
              type: 'list',
              mainProduct: {
                id: parseInt(this.dataset.productId),
                loc: parseInt(this.dataset.loc)
              },
              items: []
            };
            items.forEach(item => {
              list.items.push({
                id: parseInt(item.dataset.productId),
                title: item.dataset.title,
                loc: parseInt(item.dataset.loc),
                category: item.dataset.category
              });
            });
            viewItemListPH(list);
          }
        }
      }

      new IntersectionObserver(viewedCompleteYourLook.bind(this), {rootMargin: '0px 0px 0px 0px'}).observe(this);
    }
  }

  customElements.define('complete-your-look', CompleteYourLook);

  function removeTabContentActive() {
    document.querySelector('.product-tab__cotent.tab-active').classList.remove('tab-active');
  }

  function addTabContentActiveClass(name) {
    const contentTab = document.querySelector("[data-tab-content="+name+"]");
    contentTab.classList.add('tab-active');
  }

  function removeClassByAtrr(atrr, className) {
    const elements = document.querySelectorAll(`[${atrr}]`);
      if(elements.length > 0) {
      elements.forEach(element => {
        if(element.classList.contains(className)) {
            element.classList.remove(className);
        }
      });
    }
  }

  function tabOnClick() {
    const tabsHeader = document.querySelectorAll('[data-tab-header]');
    if(tabsHeader.length > 0) {
      tabsHeader.forEach(element => {
        element.addEventListener("click", function(event){
          if(!event.target.classList.contains("tab-active")) {
              removeClassByAtrr('data-tab-header', 'tab-active');
              event.target.classList.add("tab-active");
              removeClassByAtrr('data-tab-content', "tab-active");
              const attrValue = event.target.getAttribute("data-tab-header");
              addTabContentActiveClass(attrValue);
          }
        });
      });
    }
  }

  tabOnClick();


  } catch(e) { console.error(e); }
})();
})();
